import { render, staticRenderFns } from "./workshop.vue?vue&type=template&id=dbc97eb4&"
import script from "./workshop.vue?vue&type=script&lang=js&"
export * from "./workshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports